export default __webpack_public_path__ + "static/media/Evocon.b4535c0b.png";